export default class Lightbox {
	static init() {
		const isNeosBackend = document.body.classList.contains('neos-backend');
		if (isNeosBackend) {
			return;
		}

		this.setScrollbarWidth();

		document.querySelector('body').addEventListener('openLightbox', (e) => {
			const lightboxElement = e.target && e.target.closest('.innsbruck-lightbox');
			if(lightboxElement) {
				Lightbox.openLightbox(lightboxElement);
			}
		});

		// TODO Improve code
		var $dialogTrigger = $('.innsbruck-lightbox-trigger'),
			$pagebody = $('body');
		$dialogTrigger.click(function() {
			const lightboxElement = document.getElementById($(this).attr('data-rel'));
			Lightbox.openLightbox(lightboxElement);
			return false;
		});

		$(window).on("resize", function () {
			if ($('.innsbruck-lightbox').length && $('.innsbruck-lightbox').is(':visible')) {
				var popheighton = $('.innsbruck-lightbox .innsbruck-lightbox__content-box').height() + 60;
				var winHeight = $(window).height();
				if (popheighton > winHeight) {
					$('.innsbruck-lightbox .innsbruck-lightbox__content').addClass('taller');

				} else {
					$('.innsbruck-lightbox .innsbruck-lightbox__content').removeClass('taller');
				}
			}
		});

		//Close popup
        document.addEventListener('click', (e) => {
            if(!e.target || !e.target.closest('.innsbruck-lightbox__close-button,.innsbruck-lightbox__modal-backdrop')) {
                return; // not a popup close
            }
            e.preventDefault();
            const lightboxElement = e.target.closest('.innsbruck-lightbox');
            this.closeLightbox(lightboxElement);
        });

		// ESC close
        $('body').on('keyup', function (e) {
            if (e.key === "Escape") {
                // when the escape closes a lightbox
                $('html').removeClass('html--lightbox-overflow-hidden');
            }
        })

		var easeVal = "expo.inOut";

		$(".innsbruck-lightbox__close-button").hover(function () {
			gsap.fromTo(".innsbruck-lightbox__nav-bars .bar1", {rotation: -45}, {rotation: 0, duration: 0.25, ease: easeVal});
			gsap.fromTo(".innsbruck-lightbox__nav-bars .bar3", {rotation: 45}, {rotation: 0, duration: 0.25, ease: easeVal});
		}, function () {
			gsap.fromTo(".innsbruck-lightbox__nav-bars .bar1", {rotation: 0}, {rotation: -45, duration: 0.25, ease: easeVal});
			gsap.fromTo(".innsbruck-lightbox__nav-bars .bar3", {rotation: 0}, {rotation: 45, duration: 0.25, ease: easeVal});
		});
	}

	static setScrollbarWidth() {
		// Popup diff for scrollbar
		const popDiff = () => {
			const screenWidth = screen;
			const bodyWidth = document.querySelector('body');
			const scrollDiff = screenWidth.width - bodyWidth.offsetWidth;

			const doc = document.documentElement
			doc.style.setProperty('--pop-diff', `${scrollDiff}px`)
		}
		window.addEventListener('resize', popDiff)
		popDiff();

		// Detect Mac and Window
		if (navigator.userAgent.indexOf('Mac OS X') !== -1) {
			$("body").addClass("mac");
		} else {
			$("body").addClass("pc");
		}
	}

	constructor(element) {
	}

	static openLightbox(lightboxElement) {
		$('html').addClass('html--lightbox-overflow-hidden');

        lightboxElement.showModal();
		lightboxElement.setAttribute('style', '');
		$(lightboxElement).find('.innsbruck-lightbox__content-block').outerHeight(true);

		$('.innsbruck-lightbox .innsbruck-lightbox__modal-backdrop').fadeTo(250, 1);
		$(lightboxElement).focus();

        let $iframe = $(lightboxElement).find('iframe');
        if (!$iframe) return;

        const waitForIframeToLoad = setInterval(() => {
            if ($iframe.contents().ready()) {
                clearInterval(waitForIframeToLoad);
                onIframeLoaded();
            }
        }, 10);

        let onIframeLoaded = () => {
            lightboxElement.setAttribute('aria-label', '');
            let isOverflowing = ($iframe.contents().height() > $(window).height() - 222);
            if (isOverflowing) {
                iframeScrollHandler();
                $(lightboxElement).addClass('innsbruck-lightbox--is-overflowing');

                $iframe.contents().on("scroll", function(e) {
                    iframeScrollHandler(e);
                })
            }
        }

        let iframeScrollHandler = function(e) {
            let isAtTop;
            let isAtBottom;
            let offset = 64;

            if (e) {
                isAtTop = $(e.target).scrollTop() < offset;
                isAtBottom = $(e.target).height() - ($iframe.height() + $(e.target).scrollTop()) < offset;
            } else {
                isAtTop = $iframe.contents().scrollTop() < offset;
                isAtBottom = $iframe.contents().height() - ($iframe.height() + $iframe.contents().scrollTop()) < offset;
            }

            if (isAtTop) {
                $(lightboxElement).addClass('innsbruck-lightbox--is-at-top');
            } else {
                $(lightboxElement).removeClass('innsbruck-lightbox--is-at-top')
            }

            if (isAtBottom) {
                $(lightboxElement).addClass('innsbruck-lightbox--is-at-bottom');
            } else {
                $(lightboxElement).removeClass('innsbruck-lightbox--is-at-bottom');
            }
        }
	}

    static closeLightbox(lightboxElement) {
        $(lightboxElement).fadeOut(300, function () {
            $(this).find('.innsbruck-lightbox__modal-backdrop').fadeOut(250, function () {
                $('html').removeClass('html--lightbox-overflow-hidden');
            });
            lightboxElement.close();
        });
    }
}
